import React from 'react'
import { IntlProvider } from 'react-intl'
import baseMfeMessages from 'contrastBase/Translations'
import { formatStyles } from '../../components/react-intl-helpers'

const defaultRichTextElements = {
  ...formatStyles.bold,
  ...formatStyles.break,
  ...formatStyles.button,
  ...formatStyles.codeblock,
  ...formatStyles.codeblockwizard,
  ...formatStyles.highlight,
  ...formatStyles.info,
  ...formatStyles.italic,
  ...formatStyles.textFonts,
  ...formatStyles.warning
}

export function wrapWithI18nProvider(WrappedComponent) {
  return function I18nProvider({ locale, messages, ...props }) {
    return (
      <IntlProvider
        locale={locale}
        defaultRichTextElements={defaultRichTextElements}
        messages={{ ...messages, ...baseMfeMessages?.[locale] }}
      >
        <WrappedComponent {...props} />
      </IntlProvider>
    )
  }
}
